import { Add, EditOutlined } from "@mui/icons-material";
import { Button, CardActions, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useGetAllDepartmentsQuery } from "app/api/departments";
import { Department } from "models/Department";
import { useState } from "react";
import UpsertDepartmentDialog from "../dialogs/UpsertDepartmentDialog";
import LoadingDisplay from "components/LoadingDisplay";
import ErrorDisplay from "components/ErrorDisplay";

const DepartmentsSection: React.FC = () => {
  const { data: departments, isLoading, error } = useGetAllDepartmentsQuery();

  const [isUpsertDialogOpen, setIsUpsertDialogOpen] = useState(false);
  const [departmentToEdit, setDepartmentToEdit] = useState<Department | null>(null);

  if (isLoading) return <LoadingDisplay message="Laddar avdelningar..." />;
  if (error) return <ErrorDisplay message="Fel vid hämtning av avdelningar" />;

  return (
    <>
      {departments?.length && (
        <List disablePadding>
          {departments?.map((department) => (
            <ListItem
              key={department.id}
              divider
              secondaryAction={
                <IconButton
                  onClick={() => {
                    setDepartmentToEdit(department);
                    setIsUpsertDialogOpen(true);
                  }}
                >
                  <EditOutlined />
                </IconButton>
              }
            >
              <ListItemText
                primary={department.name}
                secondary={`Medlemmar: ${department.membersCount}`}
                slotProps={{ primary: { fontWeight: "bold" } }}
              />
            </ListItem>
          ))}
        </List>
      )}

      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => setIsUpsertDialogOpen(true)}
        >
          Ny avdelning
        </Button>
      </CardActions>

      {isUpsertDialogOpen && (
        <UpsertDepartmentDialog
          department={departmentToEdit}
          onClose={() => {
            setIsUpsertDialogOpen(false);
            setDepartmentToEdit(null);
          }}
        />
      )}
    </>
  );
};

export default DepartmentsSection;
